import { GraphicAspectRatio } from '@shared/enums/GraphicAspectRatio.js';

export const getGraphicAspectRatioOptions = () => Object.values(GraphicAspectRatio);

export const getGraphicAspectRatioValue = (aspectRatio) => {
	const [width, height] = String(aspectRatio).split(':').map(Number);
	if (!width || !height) {
		return 9 / 16;
	}

	return width / height;
};
